import React from "react";
import {Navigate, useRouteLoaderData} from "react-router";
import {LoadedData} from "./user-loader";
import router from "@/routing/Router";
import {getHomeHref} from "@/routing/homeRoutes";

const IndexRedirect = () => {
    const {user} = useRouteLoaderData("auth-root") as LoadedData;

    if (user === null) {
        return <Navigate to={router.signIn.absolutePath()} replace/>;
    }

    return <Navigate to={getHomeHref(user)} replace/>;
};

export default IndexRedirect;